import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.onlinecrackerssivakasi.in', // Replace with your API base URL
  // baseURL: 'http://localhost:3001',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add an interceptor to handle token errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Access token expired or invalid. Attempting to refresh...');
      // Logic to refresh the token
      const refreshedToken = await refreshToken(); // Implement this function
      if (refreshedToken) {
        error.config.headers['Authorization'] = `Bearer ${refreshedToken}`;
        return apiClient.request(error.config);
      }
    }
    return Promise.reject(error);
  }
);

async function refreshToken() {
  try {
    const response = await axios.post('https://api.example.com/refresh-token', {
      // Include necessary data for refreshing the token
    });
    const newToken = response.data.accessToken;
    // Store the new token (e.g., in localStorage)
    localStorage.setItem('accessToken', newToken);
    return newToken;
  } catch (err) {
    console.error('Failed to refresh token:', err);
    return null;
  }
}

/**
 * Save order details to the database.
 * @param {Object} orderDetails - The order details to be saved.
 * @returns {Promise<Object>} - The response from the API, including the orderId.
 */
export async function saveOrderDetails(orderDetails) {
  if (!orderDetails) {
    throw new Error('Invalid order details');
  }

  try {
    const response = await apiClient.post('/orders', orderDetails);
    return response.data; // Return the response, including the orderId
  } catch (error) {
    console.error('Failed to save order details:', error);
    throw error;
  }
}

export async function fetchProductsFromApi() {
  const response = await apiClient.get('/api/products');
  if (response.status !== 200) throw new Error('Failed to fetch products');
  console.log('Products loaded successfully', response.data);
  // Return only the data array, not the whole response object
  return response.data;
}

export async function saveProductsToDynamo(products) {
  const response = await apiClient.post('/api/save-products', products);
  if (response.status !== 200) throw new Error('Failed to save products');
  return response.data;
}

export async function deleteProductFromApi(productNo) {
  if (productNo === undefined || productNo === null || productNo === '') {
    throw new Error('Product number is required');
  }

  const response = await apiClient.delete(`/api/product/${productNo}`);
  if (response.status !== 200) throw new Error('Failed to delete product');
  return response.data;
}

export default apiClient;
